<template>
  <div :class="{'search-open': isSearchOpen}">
    <headroom
      :disabled="!this.$store.getters.siteOptions.header_auto_hide || isSearchOpen"
      :up-tolerance="20"
      :down-tolerance="20"
      :easing="'ease-out'"
      :speed="500"
      :style="[outerStyle, isMenuOpen?textColorOpen:textColorClosed]"
      :class="[{ hidden: headerHidden },{hide: hideHeader}, {'sticky':this.$store.getters.siteOptions.header_sticky}, {'auto-hide':this.$store.getters.siteOptions.header_auto_hide}]"
      class="header"
      @unpin="$emit('pin')"
      @pin="$emit('unpin')"
    >
      <!-- <div :class="{open: isMenuOpen}" class="header-background">
        <div :style="isMenuOpen?topStyleOpen:topStyleClosed" class="top"/>
        <div :style="isMenuOpen?bottomStyleOpen:bottomStyleClosed" class="bottom"/>
      </div> -->
      <div class="header-wrapper">
        <div :class="{open: isMenuOpen}" class="wrapper">
          <div :style="[linkStyle, labelStyle]" class="header-menu-left-container">
            <Menu
              :location="headerMenuLeft"
              @mouse-over="$emit('mouse-over')"
              @mouse-out="$emit('mouse-out')"
            />
          </div>
          <div class="logo">
            <nuxt-link :to="'/'" aria-label="&Tradition logo">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 142 21" version="1.1"><!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch --><defs><polygon id="path-1" points="0.06 0.546 132.074 0.546 132.074 21 0.06 21"/></defs><g id="&amp;tradition_logo_50mm_black_org" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group-3"><mask id="mask-2" fill="white"><use xlink:href="#path-1"/></mask><g id="Clip-2"/><path d="M111.019,21 C107.838,21 105.281,18.273 105.281,15.006 C105.281,11.796 107.838,9.068 111.019,9.068 C114.201,9.068 116.758,11.796 116.758,15.006 C116.758,18.273 114.201,21 111.019,21 M111.019,11.54 C109.23,11.54 107.809,13.102 107.809,15.006 C107.809,16.966 109.23,18.557 111.019,18.557 C112.809,18.557 114.23,16.966 114.23,15.006 C114.23,13.102 112.809,11.54 111.019,11.54 M89.365,21 C87.12,21 86.467,19.636 86.467,17.619 L86.467,11.71 L85.274,11.71 C84.961,11.71 84.734,11.455 84.734,11.171 L84.734,9.892 C84.734,9.58 84.961,9.352 85.274,9.352 L86.467,9.352 L86.467,6.199 C86.467,5.915 86.723,5.659 87.007,5.659 L88.626,5.631 C88.91,5.631 89.137,5.887 89.137,6.171 L89.137,9.352 L92.035,9.352 C92.347,9.352 92.575,9.58 92.575,9.892 L92.575,11.171 C92.575,11.455 92.347,11.71 92.035,11.71 L89.137,11.71 L89.137,17.335 C89.137,18.301 89.507,18.472 90.046,18.472 C90.643,18.472 91.438,18.131 91.779,17.96 C91.882,17.913 91.97,17.892 92.045,17.892 C92.239,17.892 92.351,18.032 92.433,18.216 L92.944,19.466 C93.086,19.778 92.972,20.006 92.688,20.148 C92.404,20.318 90.728,21 89.365,21 M65.928,21 C62.916,21 60.615,18.301 60.615,15.034 C60.615,11.71 63.059,9.068 66.212,9.068 C67.661,9.068 68.683,9.608 68.939,9.693 L68.854,2.15 C68.854,1.866 69.109,1.611 69.393,1.611 L71.041,1.611 C71.325,1.611 71.581,1.866 71.581,2.15 L71.666,20.176 C71.666,20.46 71.411,20.716 71.127,20.716 L70.274,20.716 C70.019,20.716 69.848,20.517 69.763,20.233 L69.536,19.409 C69.536,19.409 68.172,21 65.928,21 M66.496,11.54 C64.593,11.54 63.257,13.102 63.257,15.034 C63.257,16.938 64.451,18.557 66.269,18.557 C68.002,18.557 68.826,17.165 68.967,16.852 L68.967,12.222 C68.967,12.222 67.973,11.54 66.496,11.54 M50.768,21 C48.637,21 47.103,19.551 47.103,17.193 C47.103,15.119 48.75,13.529 51.648,13.529 C52.841,13.529 53.893,13.869 53.893,13.869 C53.921,12.08 53.58,11.369 52.131,11.369 C50.824,11.369 49.546,11.71 48.949,11.881 C48.9,11.893 48.854,11.899 48.811,11.899 C48.554,11.899 48.397,11.694 48.324,11.426 L48.097,10.375 C48.012,10.006 48.211,9.807 48.466,9.722 C48.665,9.637 50.285,9.068 52.387,9.068 C56.023,9.068 56.364,11.284 56.364,14.125 L56.364,20.176 C56.364,20.46 56.108,20.716 55.824,20.716 L55.029,20.716 C54.773,20.716 54.66,20.602 54.546,20.318 L54.262,19.551 C53.637,20.148 52.529,21 50.768,21 M51.875,15.29 C50.512,15.29 49.574,16 49.574,17.165 C49.574,18.188 50.256,18.983 51.307,18.983 C52.444,18.983 53.523,18.131 53.864,17.563 L53.864,15.744 C53.694,15.631 52.898,15.29 51.875,15.29 M5.739,21 C2.159,21 0,18.557 0,15.716 C0,12.307 2.926,10.631 3.949,10.034 L3.949,9.977 L3.295,9.267 C2.187,8.102 1.307,6.852 1.335,5.148 C1.335,2.989 3.04,0.546 6.534,0.546 C9.659,0.546 11.619,2.591 11.619,5.063 C11.619,7.79 8.892,9.608 7.784,10.375 L11.761,14.352 C12.386,13.159 12.595,12.271 12.68,10.822 C12.703,10.316 12.857,10.108 13.202,10.108 C13.283,10.108 13.374,10.119 13.476,10.141 L14.641,10.368 C15.294,10.481 15.152,10.993 15.124,11.249 C14.896,13.379 14.261,14.864 13.551,16.142 L16.193,18.699 C16.534,19.04 16.79,19.352 16.136,20.006 L15.398,20.744 C15.23,20.898 15.036,20.989 14.83,20.989 C14.617,20.989 14.393,20.891 14.176,20.659 L11.932,18.386 C10.909,19.551 8.864,21 5.739,21 M5.483,11.568 C4.602,12.108 2.699,13.301 2.699,15.546 C2.699,17.335 4.148,18.614 5.966,18.614 C8.011,18.614 9.403,17.534 10.227,16.568 L5.483,11.568 M6.392,2.733 C4.801,2.733 3.864,3.841 3.864,5.176 C3.835,6.284 4.545,7.108 5.511,8.074 L6.136,8.699 C6.989,8.188 9.091,7.08 9.091,5.176 C9.091,3.955 8.097,2.733 6.392,2.733 M131.534,20.716 L129.915,20.716 C129.603,20.716 129.375,20.46 129.375,20.176 L129.375,14.352 C129.375,12.534 128.495,11.54 127.017,11.54 C125.228,11.54 124.006,12.847 123.864,13.244 L123.864,20.176 C123.864,20.546 123.694,20.716 123.211,20.716 L121.733,20.716 C121.449,20.716 121.194,20.46 121.194,20.176 L121.194,9.892 C121.194,9.608 121.449,9.352 121.733,9.352 L122.557,9.352 C122.784,9.352 122.955,9.494 123.012,9.693 L123.353,10.659 C123.552,10.432 125.057,9.068 127.33,9.068 C130.796,9.068 132.074,11.512 132.074,14.466 L132.074,20.176 C132.074,20.46 131.818,20.716 131.534,20.716 M99.813,20.716 L98.194,20.716 C97.91,20.716 97.654,20.46 97.654,20.176 L97.654,9.892 C97.654,9.608 97.91,9.352 98.194,9.352 L99.813,9.352 C100.098,9.352 100.353,9.608 100.353,9.892 L100.353,20.176 C100.353,20.46 100.098,20.716 99.813,20.716 M79.408,20.716 L77.789,20.716 C77.505,20.716 77.249,20.46 77.249,20.176 L77.249,9.892 C77.249,9.608 77.505,9.352 77.789,9.352 L79.408,9.352 C79.692,9.352 79.948,9.608 79.948,9.892 L79.948,20.176 C79.948,20.46 79.692,20.716 79.408,20.716 M38.124,20.716 L36.76,20.716 C36.476,20.716 36.22,20.46 36.22,20.176 L36.22,9.892 C36.22,9.608 36.476,9.352 36.76,9.352 L37.584,9.352 C37.783,9.352 38.01,9.523 38.067,9.75 L38.379,10.716 C38.578,10.432 39.629,9.068 41.703,9.068 C42.783,9.068 44.089,9.352 43.777,10.119 L43.095,11.512 C42.997,11.727 42.831,11.821 42.654,11.821 C42.574,11.821 42.492,11.802 42.413,11.767 C42.243,11.682 41.817,11.568 41.447,11.568 C39.8,11.568 39.004,12.762 38.891,12.96 L38.891,20.176 C38.891,20.659 38.578,20.716 38.124,20.716 M28.067,20.716 L26.192,20.716 C25.908,20.716 25.652,20.46 25.652,20.176 L25.652,4.281 L21.022,4.281 C20.709,4.281 20.482,4.025 20.482,3.741 L20.482,2.15 C20.482,1.866 20.709,1.611 21.022,1.611 L33.237,1.611 C33.55,1.611 33.777,1.866 33.777,2.15 L33.777,3.741 C33.777,4.025 33.55,4.281 33.237,4.281 L28.607,4.281 L28.607,20.176 C28.607,20.46 28.351,20.716 28.067,20.716" id="Fill-1" fill="#1A1919" mask="url(#mask-2)"/></g><path d="M78.556,5.757 C77.647,5.757 76.937,5.018 76.937,4.109 C76.937,3.172 77.562,2.433 78.471,2.433 C79.408,2.433 80.232,3.172 80.232,4.109 C80.232,5.018 79.494,5.757 78.556,5.757" id="Fill-4" fill="#1A1919"/><path d="M98.961,5.757 C98.052,5.757 97.342,5.018 97.342,4.109 C97.342,3.172 97.966,2.433 98.876,2.433 C99.813,2.433 100.637,3.172 100.637,4.109 C100.637,5.018 99.899,5.757 98.961,5.757" id="Fill-5" fill="#1A1919"/><path d="M136.139,10.873 C136.139,12.434 137.409,13.704 138.97,13.704 C140.531,13.704 141.808,12.434 141.808,10.873 C141.808,9.312 140.531,8.035 138.97,8.035 C137.409,8.035 136.139,9.312 136.139,10.873 Z M136.613,10.873 C136.613,9.565 137.669,8.516 138.97,8.516 C140.279,8.516 141.327,9.565 141.327,10.873 C141.327,12.174 140.279,13.231 138.97,13.231 C137.669,13.231 136.613,12.174 136.613,10.873 Z M137.984,12.158 L138.134,12.308 L138.339,12.308 L138.489,12.158 L138.489,11.212 L139.072,11.212 L139.514,12.198 L139.656,12.308 L139.924,12.308 C140.034,12.308 140.113,12.19 140.058,12.095 C139.9,11.788 139.742,11.473 139.585,11.165 C139.805,11.11 140.223,10.897 140.223,10.306 C140.223,9.714 139.742,9.423 139.254,9.423 L138.134,9.423 L137.984,9.573 L137.984,12.158 Z M138.481,10.755 L138.481,9.856 L139.254,9.856 C139.545,9.856 139.727,10.038 139.727,10.306 C139.727,10.55 139.545,10.755 139.254,10.755 L138.481,10.755 Z" id="Fill-6" fill="#1A1919"/></g></svg>
            </nuxt-link>
          </div>
          <div :style="[linkStyle, labelStyle]" class="header-menu-right-container">
            <Menu
              :location="headerMenuRight"
              @mouse-over="$emit('mouse-over')"
              @mouse-out="$emit('mouse-out')"
            >
              <li>
                <span
                  :style="isMenuOpen?buttonStyleOpen:buttonStyle"
                  class="search-icon"
                  @click="toggleSearch()"
                ></span>
              </li>
            </Menu>
          </div>
          <div v-show="isSearchOpen" class="close"><span style="cursor:pointer;" @click="hideSearch"><span class="mobile-hide">Close</span><span class="close-icon"></span></span></div>
          <Search
            v-show="isSearchOpen"
            ref="search"
            class="v-fade"
            :class="{open: isSearchOpen}"
            :open="isSearchOpen"
            :style="[outerStyle]"
          />
          <div v-click-outside="hide" class="mobile-menu-wrapper">
            <div class="mobile-menu-trigger">
              <span style="cursor:pointer;" @click="toggleMenu()">
                <span :style="isMenuOpen?buttonStyleOpen:buttonStyle"/>
                <span :style="isMenuOpen?buttonStyleOpen:buttonStyle"/>
              </span>
            </div>
            <div v-scroll-lock="isMenuOpen" :class="{open: isMenuOpen}" class="mobile-menu-container">
              <div class="wrapper">
                <div class="mobile-menu">
                  <Menu
                    :location="headerMenuLeft"
                  />
                  <Menu
                    :location="headerMenuRight"
                    @mouse-over="$emit('mouse-over')"
                    @mouse-out="$emit('mouse-out')"
                  />
                  <div class="mobile-symbol">
                    <img src="~/assets/img/symbol.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-search-wrapper">
            <span
              style="cursor:pointer;"
              :style="isMenuOpen?buttonStyleOpen:buttonStyle"
              class="search-icon"
              @click="toggleSearch()"
            ></span>
          </div>
        </div>
      </div>
    </headroom>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { headroom } from 'vue-headroom'
import Menu from './Menu'
import bus from '@/components/bus'
import utils from '@/mixins/utils'
import Search from '@/components/Search'

export default {
  name: 'Header',

  components: {
    Menu,
    headroom,
    Search
  },

  mixins: [utils],

  data() {
    return {
      headerMenuLeft: 'header-menu-left',
      headerMenuRight: 'header-menu-right',
      headerHidden: false,
      isMenuOpen: true,
      isSearchOpen: false,
      linkStyle: {
        color: ''
      },
      outerStyle: {},
      topStyleOpen: {
        backgroundColor: ''
      },
      bottomStyleOpen: {
        backgroundColor: ''
      },
      textColorClosed: {
        color: '',
        '--underline-color': ''
      },
      textColorOpen: {
        color: ''
      },
      textColorMenu: {
        color: '',
        '--underline-color': ''
      },
      topStyleClosed: {
        backgroundColor: ''
      },
      bottomStyleClosed: {
        backgroundColor: ''
      },
      sideMenuStyle: {
        backgroundColor: ''
      },
      sideMenuBackground: {
        backgroundColor: ''
      },
      svgStyle: {
        fill: '',
        stroke: ''
      },
      svgStyleOpen: {
        fill: '',
        stroke: ''
      },
      buttonStyle: {
        backgroundColor: ''
      },
      buttonStyleOpen: {
        backgroundColor: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      textClosed: 'getTextClosed',
      textOpen: 'getTextOpen',
      textMenu: 'getTextMenu',
      backgroundClosed: 'getBackgroundClosed',
      backgroundOpen: 'getBackgroundOpen',
      backgroundMenu: 'getBackgroundMenu',
      hideHeader: 'getHideHeader'
    }),
    currentBaseTextColor() {
      return this.$store.getters.styles.baseTextColor
    },
    labelStyle() {
      return this.$store.getters.labelStyle
    }
  },
  watch: {
    currentBaseTextColor(newValue) {
      this.outerStyle.color = newValue
      // this.linkStyle.color = newValue
    },
    backgroundMenu(newValue) {
      this.sideMenuBackground.backgroundColor = newValue
    },
    backgroundOpen(newValue) {
      if (!this.$store.getters.siteOptions.header_transparent) {
        this.topStyleOpen.backgroundColor = newValue
      }
    },
    backgroundClosed(newValue) {
      if (!this.$store.getters.siteOptions.header_transparent) {
        this.topStyleClosed.backgroundColor = newValue
      }
    },
    textMenu(newValue) {
      this.textColorMenu.color = newValue
      this.textColorMenu['--underline-color'] = newValue
      this.buttonStyleOpen.backgroundColor = newValue

      this.updateHeaderMenu()
    },
    textOpen(newValue) {
      this.textColorOpen.color = newValue
      this.svgStyleOpen.fill = newValue
      this.svgStyleOpen.stroke = newValue

      this.updateHeaderOpen()
    },
    textClosed(newValue) {
      this.textColorClosed['--underline-color'] = newValue
      this.textColorClosed.color = newValue
      this.svgStyle.fill = newValue
      this.svgStyle.stroke = newValue
      this.buttonStyle.backgroundColor = newValue

      this.updateHeaderClosed()
    },
    $route(to, from) {
      this.checkQuery()
    },
  },

  created() {
    bus.$on('toggleLoading', (status = true) => {
      if (!status) {
        this.isMenuOpen = false
        this.checkQuery()
      }
    })
    bus.$on('reloadHeader', (status = true) => {
      this.updateHeader()
    })
  },

  mounted() {
    // const downTolerance = 8
    // let hasScrolled = false
    // let lastScrollTop = 0
    // let _this = this
    // // Autohide header on scroll
    // var _redraw = function () {
    //   const pageY = window.scrollY - 120
    //   if (pageY > (lastScrollTop + downTolerance)) {
    //     if (!_this.isMenuOpen) {
    //       _this.headerHidden = true
    //     }
    //   }
    //   if (pageY < lastScrollTop || pageY <= 0) {
    //     _this.headerHidden = false
    //   }
    //   lastScrollTop = pageY
    //   hasScrolled = false
    // }
    // var _onScroll = function () {
    //   if (!hasScrolled) {
    //     window.requestAnimationFrame(_redraw)
    //   }
    //   hasScrolled = true
    //   window.requestAnimationFrame(_onScroll)
    // }
    // _onScroll()
  },

  methods: {
    checkQuery() {
      if (this.$route.query.search) {
          this.isSearchOpen = true
      } else {
        this.isSearchOpen = false
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
      this.hideSearch()
    },
    toggleSearch() {
      this.isSearchOpen = !this.isSearchOpen
      this.isMenuOpen = false
      if (this.isSearchOpen) {
        this.$refs.search.focus()
      }
    },

    hide() {
      if (this.isMenuOpen) this.isMenuOpen = false
    },
    hideSearch() {
      if (this.isSearchOpen) this.isSearchOpen = false
      this.$router.replace({ query: [] })
    },
    updateHeader() {
      if (this.$store.getters.page) {
        // Set semitransparent layer from text color if no colors are set
        this.updateHeaderClosed()
        this.updateHeaderOpen()
        this.updateHeaderMenu()
      }
    },
    updateHeaderClosed() {
      this.bottomStyleClosed.backgroundColor = this.hexToRgbA(
        this.textColorClosed.color,
        0
      )
      // if (
      //   !this.$store.getters.page.acf.header_background_color_closed &&
      //   !this.$store.getters.siteOptions.header_transparent
      // ) {
      //   this.bottomStyleClosed.backgroundColor = this.hexToRgbA(
      //     this.textColorClosed.color,
      //     0.05
      //   )
      // } else {
      //   this.bottomStyleClosed.backgroundColor = this.hexToRgbA(
      //     this.textColorClosed.color,
      //     0
      //   )
      // }
    },
    updateHeaderOpen() {
      this.bottomStyleOpen.backgroundColor = this.hexToRgbA(
        this.textColorOpen.color,
        0
      )
      // if (
      //   !this.$store.getters.page.acf.header_background_color_open &&
      //   !this.$store.getters.siteOptions.header_transparent
      // ) {
      //   this.bottomStyleOpen.backgroundColor = this.hexToRgbA(
      //     this.textColorOpen.color,
      //     0.05
      //   )
      // } else {
      //   this.bottomStyleOpen.backgroundColor = this.hexToRgbA(
      //     this.textColorOpen.color,
      //     0
      //   )
      // }
    },
    updateHeaderMenu() {
      if (!this.$store.getters.page.acf.header_background_color_menu) {
        this.sideMenuStyle.backgroundColor = this.hexToRgbA(
          this.textColorMenu.color,
          0.1
        )
      } else {
        this.sideMenuStyle.backgroundColor = this.hexToRgbA(
          this.textColorMenu.color,
          0
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.v-fade {
  display: inherit !important;
  transition: opacity 0.3s;
}

.v-fade[style*='display: none;'] {
  opacity: 0;
  pointer-events: none;
  user-select: none;
}
.header {
  background-color: transparent;
  color: transparent;
  z-index: 1500;
  transition: all 400ms;
  transition: transform 500ms $easeOutExpo;
  position: relative !important;
  width: 100vw;

  &.sticky {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
  }

  &.auto-hide.hidden {
    transition-duration: 600ms;
    transform: translateY(-100%);
  }

  &.hide {
    display: none !important;
  }
}
.header-background {
  position: absolute;
  top: 0;
  left: 0;
  height: 90px;
  width: 100%;
  z-index: 1;
  transform: translateY(0);
  transition: transform 500ms $easeOutExpo;

  &.open {
    transform: translateY(0);
  }

  @include media($medium) {
    height: 60px !important;
    transform: translateY(0) !important;
  }

  .top,
  .bottom {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: all 500ms $easeOutExpo;
  }
}

.header-wrapper {
  z-index: 2;
  position: relative;

  .wrapper {
    @include grid-container-responsive;
    height: 90px;
    transition: height 500ms $easeInOutExpo;

    @include media($medium) {
      height: 80px !important;
    }
  }
}

.logo {
  align-self: center;
  z-index: 1300;
  @include grid-item(2, 6);

  @include media($medium) {
    @include grid-item(4, 5);
  }

  @include media($mobile) {
    @include grid-item(4, 2);
  }

  svg,
  svg path {
    fill: var(--main-text-color, #1A1919);
    transition: all 200ms;

    .search-open &,
    .open & {
      fill: #1A1919;
    }
  }

  a {
    width: 150px;
    text-align: center;
    margin: 0 auto;
    display: block;
  }

  img {
    max-height: 30px;
    width: auto;
  }

  .svg {
    max-height: 30px;
    transition: all 200ms;
  }
}
.search-icon {
  cursor: pointer;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: inherit;
  -webkit-mask-image: url(#{$icons-path}search.svg);
  mask-image: url(#{$icons-path}search.svg);
  mask-size: 16px;
  transform: translateY(3px);

  @include media($medium) {
    width: 20px;
    height: 20px;
    mask-size: 20px;
    transform: translateY(0);
    margin-top: 28px;
  }
}
.close-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(#{$icons-path}close.svg);
  background-size: 16px;
  transform: translateY(3px);
  margin-left: 10px;

  @include media($medium) {
    width: 20px;
    height: 20px;
    background-size: 20px;
  }
}

.mobile-menu-wrapper {
  text-align: right;
  display: none;

  @include media($medium) {
    display: block;
    @include grid-item(1);
    grid-row-start: 1;
  }
}

.mobile-search-wrapper {
  text-align: right;
  display: none;

  @include media($medium) {
    display: block;
    @include grid-item(1, 12);
    grid-row-start: 1;
  }

  @include media($mobile) {
    display: block;
    @include grid-item(1, 6);
    grid-row-start: 1;
  }
}

.mobile-menu-container {
  position: absolute;
  top: 0;
  left: 100%;
  width: 100vw;
  height: 100vh;
  transition: transform 500ms $easeOutExpo, opacity 150ms;
  z-index: 1100;
  opacity: 0;
  pointer-events: none;
  transform: translateX(-90%);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background-color: $secondary-color;

  .wrapper {
    @include grid-container();
    position: static;
  }

  &.open {
    transform: translateX(-100%);
    opacity: 1;
    pointer-events: auto;
  }

  .mobile-menu {
    position: relative;
    padding-top: 50px;
    grid-column: full;
    min-height: 100vh;
    padding-bottom: 100px;
    color: $black;

    .mobile-symbol {
      text-align: left;
      padding: 20px;
    }
  }
}

.mobile-menu-trigger {
  position: relative;
  display: inline-flex;
  z-index: 1200;
  display: none;
  margin-top: 28px;
  @include media($medium) {
    display: block;
  }
  @include media($mobile) {
  }

  > span {
    display: block;
    width: 24px;
    height: 24px;
    position: relative;
    span {
      display: block;
      width: 20px;
      height: 2px;
      transition: background-color 500ms;
      position: absolute;
      left: 2px;
      transition: all 100ms;

      .search-open &,
      .open & {
        background-color: $black !important;
      }

      &:first-child {
        top: 6px;

        .open & {
          top: 11px;
          transform: rotate(-45deg);
        }
      }
      &:last-child {
        top: 16px;

        .open & {
          top: 11px;
          transform: rotate(45deg);
        }
      }
    }
  }
}

.header-menu-left-container {
  transition: opacity 100ms;
  align-self: center;
  @include grid-item(5, 1);

  @include media($medium) {
    display: none;
  }

  .open & {
    opacity: 0;
  }
}
.header-menu-right-container {
  transition: opacity 100ms;
  align-self: center;
  @include grid-item(5, 8);
  grid-row-start: 1;
  @include media($medium) {
    display: none;
  }

  .open & {
    opacity: 0;
  }
}
.close {
  z-index: 2;
  align-self: center;
  text-align: right;
  @include grid-item(1, 12);
  grid-row-start: 1;
  color: $black;

  @include media($mobile) {
    @include grid-item(1, 6);
    grid-row-start: 1;
  }

  .mobile-hide {
    @include media($medium) {
      display: none;
    }
  }
}
</style>
